import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenericMessageDialogComponent } from '@app/dialogs/generic-message-dialog/generic-message-dialog.component';
import { TabletLoginDialogComponent } from '@app/dialogs/tablet-login-dialog/tablet-login-dialog.component';
import LocalStorage from '@app/helpers/LocalStorage';
import { GenericMessage } from '@app/interfaces/generic-message';
import { TableGuestStayResult } from '@app/interfaces/TableGuestStayResult';
import { LocalStorageService } from '@app/services/localstorage.service';
import { ReservationService } from '@app/services/reservation.service';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { firstValueFrom, Subscription } from 'rxjs';
import jwt_decode from "jwt-decode";
import { SubscriberParameterService } from '../../../../../froexishared/src/services/SubscriberParameter.service';
import { BrandingService } from '../../../../../froexishared/src/services/branding.service';
import HwUtils from '@app/helpers/HwUtils';
import { BrandingDto } from '../../../../../froexishared/src/dto/BrandingDto';
import SessionStorage from '@app/helpers/SessionStorage';
import { SubscriberParameter } from '../../../../../froexishared/src/dto/SubscriberParameter';

@AutoUnsubscribe()
@Component({
  selector: 'start-checkin',
  templateUrl: './start-checkin.component.html',
  styleUrls: ['./start-checkin.component.scss']
})
export class StartCheckinComponent implements OnInit, OnDestroy {

  getGuestStayUuId$: Subscription;
  buttonDisabled: boolean;

  constructor(
    private router: Router,
    private reservationService: ReservationService,
    private localStorageService: LocalStorageService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private brandingService: BrandingService,
    private subscriberParamaterService: SubscriberParameterService
  ) { }


  ngOnDestroy(): void {
    this.getGuestStayUuId$?.unsubscribe();
  }
  ngOnInit(): void {
    if (this.localStorageService.getDeviceId() == null && this.localStorageService.getHotel3pId() == null) {
      const dialogRef = this.dialog.open(TabletLoginDialogComponent, {
        disableClose: true,
        hasBackdrop: false,
        width: "50vw",
      })
      dialogRef.afterClosed().subscribe(res => {
        this.buttonDisabled = this.localStorageService.getDeviceId() == null || this.localStorageService.getHotel3pId() == null || !LocalStorage.IsTabletMode ? true : false
      })
    } else {
      this.buttonDisabled = this.localStorageService.getDeviceId() == null || this.localStorageService.getHotel3pId() == null || !LocalStorage.IsTabletMode ? true : false
    }
  }

  async submit() {

    // let result :  TableGuestStayResult;
    sessionStorage.clear();

    SessionStorage.MrzData = undefined;
    SessionStorage.FaceImageFromCard = '';
    SessionStorage.Selfie = '';

    if (LocalStorage.IsTabletMode) {

    
                  
      //  // branding adatok betöltése
      // let bran = await firstValueFrom(this.brandingService.LoadOnebySubscriber(HwUtils.getSubscriber(), HwUtils.getHotelId()))
      // const br = bran  as BrandingDto;
      // if (br) {
      //   SessionStorage.BrandingData = br;
      // }

      if (LocalStorage.OperationMode == "VIP") {
        let res = await firstValueFrom(this.reservationService.GetTableGuestStayUuid(this.localStorageService.getHotel3pId(), this.localStorageService.getDeviceId()))
        let result = res as TableGuestStayResult;
        if (result.Success && result.GuestStayUuid !== "") {
          this.router.navigate(["/"], {
            queryParams: {
              guestStayUuid: result.GuestStayUuid,
              hotel3pId: this.localStorageService.getHotel3pId()
            },
            replaceUrl: true,
            onSameUrlNavigation: 'reload',
            queryParamsHandling: 'merge',
            skipLocationChange: false
          }).then(() => {
            // window.location.reload()
          })
        }
        else {
          let messageData: GenericMessage = { messageText: this.translate.instant('common.device_already_in_use'), messageType: 'ERROR', showIcon: true }
          const dialogRef = this.dialog.open(GenericMessageDialogComponent, {
            disableClose: true,
            hasBackdrop: true,
            width: "40%",
            data: messageData
          })
        }
      } else {
        // csoportos mód
        let bran = await firstValueFrom(this.brandingService.LoadOnebySubscriber(HwUtils.getSubscriber(), HwUtils.getHotelId()))
        const br = bran as BrandingDto;
        if (br) {
          SessionStorage.BrandingData = br;
        }

        const tabletToken = jwt_decode(LocalStorage.TabletToken)
  // "SubscriberCode": "DEM-DEM",
  // "SubscriberHtlNum": "1",

        let params = await firstValueFrom (this.subscriberParamaterService.loadAll(tabletToken["SubscriberCode"], parseInt(tabletToken["SubscriberHtlNum"])))
        const parameters = params as SubscriberParameter[];
        SessionStorage.ChatVisibility = parameters.find(item => item.Param_Typecode == "CHAT_VISIBILITY").Param_String_Value
        SessionStorage.PhotoInTabletMode = parameters.find(item => item.Param_Typecode == "PHOTO_IN_EXI_TABLET").Param_Int_Value
        SessionStorage.PhotoInExi = parameters.find(item => item.Param_Typecode == "PHOTO_IN_EXI").Param_Int_Value
        SessionStorage.PhotoInTabletApp = parameters.find(item => item.Param_Typecode == "PHOTO_IN_TABLET_APP").Param_Int_Value;
        this.router.navigate(["/languageselection"])
      }
    } else {

    }
  }


  released() {
    const dialogRef = this.dialog.open(TabletLoginDialogComponent, {
      disableClose: true,
      hasBackdrop: false,
      width: "50vw",
    })
    dialogRef.afterClosed().subscribe(res => {
      if( res ) {
        this.router.navigateByUrl("/tabletsetup")
      }
     
    })
  }
}
